import { SafeHTML } from '@thoughtspot/radiant-react/widgets/safe-html';
import React, { useEffect } from 'react';
import styles from '../../styles/tooltip.module.scss';
export const TooltipComponent = ({ isVisible, tooltipConfig, tooltipEl, }) => {
    const positionTooltip = (positionAttributes) => {
        if (tooltipEl.current) {
            Object.entries(positionAttributes).forEach(([attr, value]) => {
                tooltipEl.current.style[attr] = value && `${value}px`;
            });
        }
        tooltipEl.current.style.display = 'block';
    };
    useEffect(() => {
        let timer;
        if (tooltipConfig && isVisible) {
            timer = window.setTimeout(() => {
                positionTooltip(tooltipConfig);
            }, 500);
        }
        return () => clearTimeout(timer);
    }, [isVisible, tooltipConfig]);
    return (React.createElement("div", { className: styles.tooltipContainer }, isVisible ? (React.createElement("div", { className: styles.customTooltip, ref: tooltipEl },
        React.createElement("ul", null,
            Object.entries(tooltipConfig.content).map(([key, value]) => (React.createElement("li", { key: key, className: styles.customTooltipRow },
                React.createElement("span", { className: styles.bkKey }, key),
                React.createElement("span", { className: styles.bkValue }, value)))),
            tooltipConfig.customTooltipContent.map(value => {
                return (React.createElement("li", { className: styles.customTooltipRow },
                    React.createElement("span", { className: styles.bkValue },
                        React.createElement(SafeHTML, { html: value }))));
            })))) : null));
};
//# sourceMappingURL=tooltip.js.map